import React from 'react';
import { Switch, Route } from 'react-router-dom';
import CurriculumManagerContainer from './containers/curriculum-manager/index';

const Routes = () => (
    <Switch>
        <Route component={CurriculumManagerContainer} path="/" />
    </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./app/routes.js